import { render, staticRenderFns } from "./AIAssistanceModal.vue?vue&type=template&id=23c01e42&scoped=true&"
import script from "./AIAssistanceModal.vue?vue&type=script&lang=js&"
export * from "./AIAssistanceModal.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistanceModal.vue?vue&type=style&index=0&id=23c01e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c01e42",
  null
  
)

export default component.exports